import { isChinaRegion } from '@barracuda/shared/utils/feature-flags';

const getProductPrice = (region: 'CN' | 'US' | undefined = undefined) => {
  if (!region) {
    region = isChinaRegion() ? 'CN' : 'US';
  }

  switch (region) {
    case 'CN':
      return '¥490';
    case 'US':
    default:
      return '$70';
  }
};

export { getProductPrice };
